// extracted by mini-css-extract-plugin
export default {"canvasWrap":"Canvas_canvasWrap__c3ZkU","svg":"Canvas_svg__Q5rC3","tooltip":"Canvas_tooltip__afcXo"};